module.exports = __webpack_public_path__ + "static/img/tab2.23b5ee3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/tab2.jpg
// module id = 3142
// module chunks = 1